export const getNotarizationDocumentAvailability = (permitData = {}) => {
  const selectedDocs = permitData?.selected_documents || [];
  const selectedDocsCount = selectedDocs.length;
  const isTrueNocOnlyPackage =
    selectedDocsCount > 0 && selectedDocs.every((doc) => doc?.is_noc === true);
  const allSelectedDocsCreated =
    selectedDocsCount > 0 && selectedDocs.every((doc) => doc?.created === true);
  const singleSelectedDocReady =
    selectedDocsCount === 1 && selectedDocs[0]?.created === true;
  const hasSelectedSigningDocs = selectedDocs.some(
    (doc) =>
      doc?.signatures?.owner?.sign === true ||
      doc?.signatures?.owner?.notary === true ||
      doc?.signatures?.contractor?.sign === true ||
      doc?.signatures?.contractor?.notary === true,
  );
  const canStartNocOnly = permitData?.noc_created === true;
  const canStartAllDocuments =
    !isTrueNocOnlyPackage &&
    (permitData?.permit_package_created === true ||
      permitData?.documents?.pp_ntbo?.is_created === true ||
      singleSelectedDocReady ||
      (selectedDocsCount > 1 &&
        allSelectedDocsCreated &&
        hasSelectedSigningDocs));

  return {
    isTrueNocOnlyPackage,
    canStartNocOnly,
    canStartAllDocuments,
  };
};

export const getInitialNotarizationDocumentType = (permitData = {}) => {
  const { canStartNocOnly, canStartAllDocuments } =
    getNotarizationDocumentAvailability(permitData);

  if (canStartNocOnly && !canStartAllDocuments) {
    return 1;
  }

  if (canStartAllDocuments) {
    return 0;
  }

  return null;
};
